// The client never decides what time or day it is (Daily Structure): it
// measures its offset from the server on every response that carries
// serverTime and derives countdowns from that.
let offsetMs = 0;
let synced = false;

export function syncClock(serverTime: number): void {
  offsetMs = serverTime - Date.now();
  synced = true;
}

export function clockSynced(): boolean {
  return synced;
}

export function serverNow(): number {
  return Date.now() + offsetMs;
}

const two = (n: number) => String(n).padStart(2, '0');

/** hh:mm:ss with leading zeros, never negative. */
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return `${two(h)}:${two(m)}:${two(s)}`;
}

const DAY_MS = 86_400_000;

/** A week's or a month's time left: whole days while more than 48 hours remain, then hh:mm:ss. */
export function formatTimeLeft(ms: number): string {
  if (ms > 2 * DAY_MS) return `${Math.floor(ms / DAY_MS)} days left`;
  return formatCountdown(ms);
}

/** When the week of `weekStart` (its Monday) gives way to the next: the next Monday at 00:00 UTC. */
export function weekResetAt(weekStart: string): number {
  return Date.parse(`${weekStart}T00:00:00Z`) + 7 * DAY_MS;
}

/** When `month` (yyyy-mm) gives way to the next: the 1st of the next month at 00:00 UTC. */
export function monthResetAt(month: string): number {
  const [y, m] = month.split('-').map(Number);
  return Date.UTC(y, m, 1);
}

// The date formats are in the shared core (share/caption.ts), which the
// Worker's share page uses too.
export { formatFullDate, formatShortDate } from '@wits/core';
